import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Header from './components/Header';
import Homepage from './pages/Homepage';
import ProspectsTerminalPage from './pages/ProspectsTerminalPage';
import ProspectPage from './pages/ProspectPage/ProspectPage';
import Boards from './pages/Boards';
import BigBoardMocksPage from './pages/BigBoardMocksPage';
import CollectiveMockDraftPage from './pages/CollectiveMockDraftPage';
import Redrafts from './pages/Redrafts/Redrafts';
import JaylenBrown2016Redraft from './pages/Redrafts/JaylenBrown2016Redraft';
import LanguageContextProvider from './context/LanguageContext';
import UpdateContextProvider from './context/UpdateContext';
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <UpdateContextProvider>
          <LanguageContextProvider>
            <div className="App h-dvh min-w-screen">
              <Header />
              <Routes>
                <Route path="/" element={<Homepage />} />
                <Route path="/boards" element={<Boards />} />
                <Route path="/prospects" element={<ProspectsTerminalPage />} />
                <Route path="/big-board-mocks" element={<BigBoardMocksPage />} />
                <Route path="/collective-mock-draft" element={<CollectiveMockDraftPage />} />
                <Route path="/redrafts" element={<Redrafts />} />
                <Route path="/redrafts/jaylen-brown-2016-redraft" element={<JaylenBrown2016Redraft />} />
                <Route path="/prospects/:year/:id/:full_name" element={<ProspectPage />} />
              </Routes>
            </div>
          </LanguageContextProvider>
        </UpdateContextProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;